export const DEAL_TABS = {
  GENERAL: "general",
  TRANSPORTATION_STAGES: "transportation_stages",
  PLANNED_CALCULATION: "planned_calculation",
  REVENUE_EXPENSE: "revenue_expense",
  DOCUMENTS: "documents",
  OVERHEAD_EXPENSES: "overhead_expenses",
  CONFIGURATION: "configuration",
  TRACKING: "tracking",
} as const;

export type DealTab = (typeof DEAL_TABS)[keyof typeof DEAL_TABS];

export const isDealTab = (value: string): value is DealTab => Object.values(DEAL_TABS).some((tab) => tab === value);

export const buildDealPath = (id: number | string, tab: DealTab = DEAL_TABS.GENERAL) =>
  `/deals/${id}${tab === DEAL_TABS.GENERAL ? "" : `/${tab}`}`;
